import { Outlet } from "react-router-dom";

import { useUnauthorizedRedirect } from "@/hooks/use-unauthorized-redirect";

export default function ConnectLayout() {
  useUnauthorizedRedirect();
  return <Outlet />;
}
